/**
 * Import all front-end JS scripts.
 * 
 * Compiles to assets/scripts/theme-scripts.js
 */

 /* eslint-disable no-unused-vars */

 // Import ES6 modules (recommended)
 // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import { mainNavigation, centerDropdownMenu, trapTabOrderMobile } from './base/main-navigation';
import responsiveEmbeds from './base/embeds';
import getAccordionItems from './base/accordion';
import insightsNavigation from './base/insights-navigation';
import searchModalToggle from './base/search-modal'
import modal from './base/modal'

import './base/slider';
import './base/calculator.js';
import './base/scroll-top.js';

import './base/a11y.js';

// Or import entire JS files the "old school" way
// import './test.js'